export default __webpack_public_path__ + "static/media/join-renew.4c69d869.png";